import fetch from "auth/FetchInterceptor";

const SettingService = {};

SettingService.getSetting = function () {
  return fetch({
    url: `/settings`,
    method: "GET",
  });
};

SettingService.updateSetting = function (data) {
  return fetch({
    url: `/settings/`,
    method: "PUT",
    data,
  });
};

SettingService.reviews = function (page = 1, headers = {}) {
  return fetch({
    url: `/reviews/?page=${page}`,
    method: "GET",
    headers: {
      ...headers,
    },
  });
};

SettingService.updateReviewStatus = function (reviewId, statusValue) {
  return fetch({
    url: `/reviews/${reviewId}/`,
    method: "PATCH",
    data: { status: statusValue },
  });
};

SettingService.deleteReview = function (reviewId) {
  return fetch({
    url: `/reviews/${reviewId}/`,
    method: "DELETE",
  });
};

SettingService.paymentKeys = function () {
  return fetch({
    url: `/payment-keys/`,
    method: "GET",
  });
};

// Enhanced Shipping APIs
SettingService.shipping = function () {
  return fetch({
    url: `/shippings/`,
    method: "GET",
  });
};

// Country Shipping Settings
SettingService.getCountryShipping = function (countryId = null) {
  let url = `/shippings/country/`;
  if (countryId) url += `?country_id=${countryId}`;
  return fetch({
    url,
    method: "GET",
  });
};

SettingService.updateCountryShipping = function (data) {
  return fetch({
    url: `/shippings/country/`,
    method: "POST",
    data,
  });
};

SettingService.deleteCountryShipping = function (countryId) {
  return fetch({
    url: `/shippings/country/?country_id=${countryId}`,
    method: "DELETE",
  });
};

// Zone Shipping Settings
SettingService.getZoneShipping = function (zoneId = null, countryId = null) {
  let url = `/shippings/zone/`;
  const params = [];
  if (zoneId) params.push(`zone_id=${zoneId}`);
  if (countryId) params.push(`country_id=${countryId}`);
  if (params.length > 0) url += `?${params.join("&")}`;
  return fetch({
    url,
    method: "GET",
  });
};

SettingService.updateZoneShipping = function (data) {
  return fetch({
    url: `/shippings/zone/`,
    method: "POST",
    data,
  });
};

SettingService.deleteZoneShipping = function (zoneId) {
  return fetch({
    url: `/shippings/zone/?zone_id=${zoneId}`,
    method: "DELETE",
  });
};

// Area Shipping Settings
SettingService.getAreaShipping = function (
  areaId = null,
  zoneId = null,
  countryId = null,
) {
  let url = `/shippings/area/`;
  const params = [];
  if (areaId) params.push(`area_id=${areaId}`);
  if (zoneId) params.push(`zone_id=${zoneId}`);
  if (countryId) params.push(`country_id=${countryId}`);
  if (params.length > 0) url += `?${params.join("&")}`;
  return fetch({
    url,
    method: "GET",
  });
};

SettingService.updateAreaShipping = function (data) {
  return fetch({
    url: `/shippings/area/`,
    method: "POST",
    data,
  });
};

SettingService.deleteAreaShipping = function (areaId) {
  return fetch({
    url: `/shippings/area/?area_id=${areaId}`,
    method: "DELETE",
  });
};

// Bulk Shipping Settings
SettingService.bulkUpdateShipping = function (data) {
  return fetch({
    url: `/shippings/bulk/`,
    method: "POST",
    data,
  });
};

// Calculate Shipping (Public)
SettingService.calculateShipping = function (data) {
  return fetch({
    url: `/oc/calculate-shipping/`,
    method: "POST",
    data,
    headers: {
      "Store-ID": localStorage.getItem("store_id") || "1",
    },
  });
};

SettingService.meta_keys = function () {
  return fetch({
    url: `/meta-app-credentials/`,
    method: "GET",
  });
};

SettingService.getMetaCredentials = function () {
  return fetch({
    url: `/meta-app-credentials/`,
    method: "GET",
  });
};

SettingService.updateMetaCredentials = function (data) {
  return fetch({
    url: `/meta-app-credentials/`,
    method: "POST",
    data,
  });
};

SettingService.getZone = function () {
  return fetch({
    url: `/zones/`,
    method: "GET",
  });
};

// Zone Delivery Prices APIs
SettingService.getZoneDeliveryPrices = function () {
  return fetch({
    url: `/zone-delivery-prices/`,
    method: "GET",
  });
};

SettingService.createZoneDeliveryPrice = function (data) {
  return fetch({
    url: `/zone-delivery-prices/`,
    method: "POST",
    data,
  });
};

SettingService.updateZoneDeliveryPrice = function (id, data) {
  return fetch({
    url: `/zone-delivery-prices/${id}/`,
    method: "PUT",
    data,
  });
};

SettingService.deleteZoneDeliveryPrice = function (id) {
  return fetch({
    url: `/zone-delivery-prices/${id}/`,
    method: "DELETE",
  });
};

SettingService.bulkUpdateZoneDeliveryPrices = function (data) {
  return fetch({
    url: `/zone-delivery-prices/bulk/`,
    method: "POST",
    data,
  });
};

// Area APIs
SettingService.getAreasByZone = function (zoneId) {
  return fetch({
    url: `/areas/?zone_id=${zoneId}`,
    method: "GET",
  });
};

SettingService.getAreaDeliveryPrices = function () {
  return fetch({
    url: `/area-delivery-prices/`,
    method: "GET",
  });
};

SettingService.createAreaDeliveryPrice = function (data) {
  return fetch({
    url: `/area-delivery-prices/`,
    method: "POST",
    data,
  });
};

SettingService.updateAreaDeliveryPrice = function (id, data) {
  return fetch({
    url: `/area-delivery-prices/${id}/`,
    method: "PUT",
    data,
  });
};

SettingService.deleteAreaDeliveryPrice = function (id) {
  return fetch({
    url: `/area-delivery-prices/${id}/`,
    method: "DELETE",
  });
};

SettingService.bulkCreateAreaDeliveryPrices = function (data) {
  return fetch({
    url: `/area-delivery-prices/bulk/`,
    method: "POST",
    data,
  });
};

SettingService.getAreaDeliveryPrice = function (data) {
  return fetch({
    url: `/get-area-delivery-price/`,
    method: "POST",
    data,
    headers: {
      "Store-ID": localStorage.getItem("store_id") || "1",
    },
  });
};

SettingService.getStripeKeys = function () {
  return fetch({
    url: `/payment-stripe-keys/`,
    method: "GET",
  });
};

SettingService.updateStripeKeys = function (data) {
  return fetch({
    url: `/payment-stripe-keys/`,
    method: "PUT",
    data,
  });
};

// CBK Payment Keys APIs
SettingService.getCbkKeys = function () {
  return fetch({
    url: `/payment-cbk-keys/`,
    method: "GET",
  });
};

SettingService.updateCbkKeys = function (data) {
  return fetch({
    url: `/payment-cbk-keys/`,
    method: "POST",
    data,
  });
};

// Tabby Payment Keys APIs
SettingService.getTabbyKeys = function () {
  return fetch({
    url: `/payment-tabby-keys/`,
    method: "GET",
  });
};

SettingService.updateTabbyKeys = function (data) {
  return fetch({
    url: `/payment-tabby-keys/`,
    method: "POST",
    data,
  });
};

// UPayment Keys APIs
SettingService.getUPaymentKeys = function () {
  return fetch({
    url: `/payment-upayment-keys/`,
    method: "GET",
  });
};

SettingService.updateUPaymentKeys = function (data) {
  return fetch({
    url: `/payment-upayment-keys/`,
    method: "POST",
    data,
  });
};

// Taly Payment Keys APIs
SettingService.getTalyKeys = function () {
  return fetch({
    url: `/payment-taly-keys/`,
    method: "GET",
  });
};

SettingService.updateTalyKeys = function (data) {
  return fetch({
    url: `/payment-taly-keys/`,
    method: "POST",
    data,
  });
};

// Allowmena shipping integration APIs
SettingService.getAllowmenaKeys = function () {
  return fetch({
    url: `/shipping-allowmena-keys/`,
    method: "GET",
  });
};

SettingService.updateAllowmenaKeys = function (data) {
  return fetch({
    url: `/shipping-allowmena-keys/`,
    method: "POST",
    data,
  });
};

SettingService.generateAllowmenaBearer = function (data = {}) {
  return fetch({
    url: `/shipping-allowmena-keys/`,
    method: "POST",
    data: { ...data, auto_generate_bearer: true },
  });
};

// Tehseel Payment Keys APIs
SettingService.getTehseelKeys = function () {
  return fetch({
    url: `/payment-tehseel-keys/`,
    method: "GET",
  });
};

SettingService.updateTehseelKeys = function (data) {
  return fetch({
    url: `/payment-tehseel-keys/`,
    method: "POST",
    data,
  });
};

// Email Settings APIs
SettingService.getEmailSettings = function () {
  return fetch({
    url: `/email-settings/`,
    method: "GET",
  });
};

SettingService.updateEmailSettings = function (data) {
  return fetch({
    url: `/email-settings/`,
    method: "PUT",
    data,
  });
};

SettingService.resetEmailSettings = function () {
  return fetch({
    url: `/email-settings/`,
    method: "DELETE",
  });
};

// Tax Settings APIs
SettingService.getTaxSettings = function () {
  return fetch({
    url: `/tax-settings/`,
    method: "GET",
  });
};

SettingService.updateTaxSettings = function (data) {
  return fetch({
    url: `/tax-settings/`,
    method: "PUT",
    data,
  });
};

// Country Settings APIs
SettingService.getCountrySettings = function () {
  return fetch({
    url: `/settings/countries/`,
    method: "GET",
  });
};

SettingService.updateCountrySettings = function (data) {
  return fetch({
    url: `/settings/countries/`,
    method: "POST",
    data,
  });
};

SettingService.deleteCountrySettings = function () {
  return fetch({
    url: `/settings/countries/`,
    method: "DELETE",
  });
};

SettingService.getCountryZones = function (countryId = null, zoneId = null) {
  let url = `/settings/countries/zones/`;
  const params = [];
  if (countryId) params.push(`country_id=${countryId}`);
  if (zoneId) params.push(`zone_id=${zoneId}`);
  if (params.length > 0) url += `?${params.join("&")}`;
  return fetch({
    url,
    method: "GET",
  });
};

// Area Management APIs
SettingService.getAreas = function (zoneId) {
  return fetch({
    url: `/settings/areas/?zone_id=${zoneId}`,
    method: "GET",
  });
};

SettingService.createArea = function (data) {
  return fetch({
    url: `/settings/areas/`,
    method: "POST",
    data,
  });
};

SettingService.updateArea = function (data) {
  return fetch({
    url: `/settings/areas/`,
    method: "PUT",
    data,
  });
};

SettingService.deleteArea = function (areaId) {
  return fetch({
    url: `/settings/areas/?area_id=${areaId}`,
    method: "DELETE",
  });
};

SettingService.bulkCreateAreas = function (data) {
  return fetch({
    url: `/settings/areas/bulk/`,
    method: "POST",
    data,
  });
};

// Footer Settings APIs
SettingService.getFooterSettings = function () {
  return fetch({
    url: `/footer-settings/`,
    method: "GET",
  });
};

SettingService.updateFooterSettings = function (data) {
  return fetch({
    url: `/footer-settings/`,
    method: "PUT",
    data,
  });
};

SettingService.generateFooterCode = function (data) {
  return fetch({
    url: `/generate-footer-code/`,
    method: "POST",
    data,
  });
};

// Header Settings APIs
SettingService.getHeaderSettings = function () {
  return fetch({
    url: `/header-settings/`,
    method: "GET",
  });
};

SettingService.updateHeaderSettings = function (data) {
  return fetch({
    url: `/header-settings/`,
    method: "PUT",
    data,
  });
};

// SMS Settings APIs
SettingService.getSmsSettings = function () {
  return fetch({
    url: `/sms-settings/`,
    method: "GET",
  });
};

SettingService.updateSmsSettings = function (data) {
  return fetch({
    url: `/sms-settings/`,
    method: "PUT",
    data,
  });
};

// Pixel Tracking Settings APIs
SettingService.getPixelSettings = function () {
  return fetch({
    url: `/pixel-settings/`,
    method: "GET",
  });
};

SettingService.updatePixelSettings = function (data) {
  return fetch({
    url: `/pixel-settings/`,
    method: "PUT",
    data,
  });
};

// Trustpilot Settings APIs
SettingService.getTrustpilotSettings = function () {
  return fetch({
    url: `/trustpilot-settings/`,
    method: "GET",
  });
};

SettingService.updateTrustpilotSettings = function (data) {
  return fetch({
    url: `/trustpilot-settings/`,
    method: "PUT",
    data,
  });
};

SettingService.getGoogleCustomerReviewsSettings = function () {
  return fetch({
    url: `/google-customer-reviews-settings/`,
    method: "GET",
  });
};

SettingService.updateGoogleCustomerReviewsSettings = function (data) {
  return fetch({
    url: `/google-customer-reviews-settings/`,
    method: "PUT",
    data,
  });
};

SettingService.getFirebaseWebSettings = function () {
  return fetch({
    url: `/firebase-settings/`,
    method: "GET",
  });
};

SettingService.updateFirebaseWebSettings = function (data) {
  return fetch({
    url: `/firebase-settings/`,
    method: "PUT",
    data,
  });
};

// Theme Colors Settings APIs
SettingService.getThemeColors = function () {
  return fetch({
    url: `/theme-colors/`,
    method: "GET",
  });
};

SettingService.updateThemeColors = function (data) {
  return fetch({
    url: `/theme-colors/`,
    method: "PUT",
    data,
  });
};

export default SettingService;
